import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roundup'
})
export class RoundUpPipe implements PipeTransform {

  transform(value: number): number {
    return Math.ceil(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/round-up-pipe/round-up.pipe.ts